import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import image from "_assets/images/PRM-Logo-PNG/ranking.png";

const Ranking = () => {
    return (
        <>
          <Container>
            <Row>
              <div>
                <img
                  src={image}
                  height={500}
                />
              </div>
            </Row>
          </Container>      
        </>
    );
};

export default Ranking;
